import {
  createLightTheme,
  tokens,
  type BrandVariants,
  type Theme,
} from '@fluentui/react-components'

const brandVariants: BrandVariants = {
  10: '#492A10',
  20: '#5C3411',
  30: '#6F3E12',
  40: '#834812',
  50: '#975311',
  60: '#AC5D10',
  70: '#C1680E',
  80: '#D6730B',
  90: '#EC7E05',
  100: '#FF8C16',
  110: '#FFA455',
  120: '#FFBA82',
  130: '#FFCFA9',
  140: '#FFCFA9',
  150: '#FFCFA9',
  160: '#FFCFA9',
}

/**
 * Extended theme type that includes custom application-specific tokens
 * Extends Fluent UI Theme with additional properties.
 */
export type AppTheme = Theme & {
  colorWhite: string
  colorBlack: string
  colorTransparent: string
  colorAccent: string
}

/**
 * CSS variable tokens mapping for the application theme
 * Includes all Fluent UI tokens plus custom application tokens
 * Used in CSS for dynamic theme color references (e.g., var(--colorWhite))
 */
export const appTokens: Record<keyof AppTheme, string> = {
  ...tokens,
  colorWhite: 'var(--colorWhite)',
  colorBlack: 'var(--colorBlack)',
  colorTransparent: 'var(--colorTransparent)',
  colorAccent: 'var(--colorAccent)',
}

// export const themeModes = ['system', 'light', 'dark'] as const
// export type ThemeMode = (typeof themeModes)[number]

export const theme: AppTheme = {
  ...createLightTheme(brandVariants),
  fontFamilyBase: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  fontFamilyMonospace: "'JetBrains Mono', 'Consolas', 'Monaco', 'Courier New', monospace",
  fontFamilyNumeric: "'JetBrains Mono', monospace",
  colorWhite: '#FFFFFF',
  colorBlack: '#000000',
  colorTransparent: 'transparent',
  colorAccent: '#0E1820',
}
